import { render, staticRenderFns } from "./ActionDetails.vue?vue&type=template&id=52874d72"
import script from "./ActionDetails.vue?vue&type=script&lang=js"
export * from "./ActionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ActionDetails.vue?vue&type=custom&index=0&blockType=stype&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports